import { formatBytes } from "@shared-core/domain/formatters";

// The client-side rules for a customer's artwork file on the quote and order
// pages, the same as the standalone artwork check's (PortalArtworkCheckPage
// states them inline; the two converge when the artwork family re-homes the
// check, row 3). PDF only, deliberately: the preflight profile is a PDF
// analysis profile, so an image would get a meaningless verdict.
//
// 500 MB, set by the business owner. A client-side hint until uploads stream
// to disk (order to invoice doc 39 §11): today the API buffers a whole file.
export const MAX_ARTWORK_FILE_SIZE_BYTES = 500_000_000;

/** Why this file can't be checked, in the customer's words; null when it can. */
export function validateArtworkPdf(file: File): string | null {
  const looksLikePdf =
    file.type === "application/pdf" || file.name.toLowerCase().endsWith(".pdf");
  if (!looksLikePdf) {
    return "We can only check PDFs. Please export your artwork as a PDF and try again.";
  }
  if (file.size > MAX_ARTWORK_FILE_SIZE_BYTES) {
    return `That file is ${formatBytes(file.size)}: we can check files up to ${formatBytes(MAX_ARTWORK_FILE_SIZE_BYTES)}. Try flattening or re-exporting at a smaller size.`;
  }
  return null;
}
